import Dialog from '@/components/Dialog'
import IcoMoon from '@/components/IcoMoon'
import { useTranslation } from 'next-i18next'
import * as styles from './style'

export default function AccessRestrictedDialog(): JSX.Element {
  const { t } = useTranslation('common')

  return (
    <Dialog customClass={styles.customClass}>
      <div className={styles.container}>
        <div className={styles.imageContainer}>
          <IcoMoon icon="lock" size={64} />
        </div>
        <h1 className={styles.heading}>{t('accessRestricted.title')} </h1>
        <h3 className={styles.subheading}>{t('accessRestricted.subtitle')}</h3>
      </div>
    </Dialog>
  )
}
